export const CLEAR_ALL_VALUE = '__fronton_list_clear_all__';